/*! Combined Swiper initializations: custom-slider, review-slider, custom-layout-slider, video-slider - optimized */

(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function bindButtonsOnce(buttons, target) {
    if (!target) return;

    buttons.forEach(function (button) {
      if (button.dataset.swiperButtonBound === "true") return;

      button.dataset.swiperButtonBound = "true";
      button.addEventListener("click", function () {
        target.click();
      });
    });
  }

  function safeUpdateSwiper(swiperEl) {
    if (!swiperEl || !swiperEl.swiper) return;

    window.requestAnimationFrame(function () {
      try {
        swiperEl.swiper.update();
      } catch (error) {}
    });
  }

  function initCustomSwiper() {
    var swiperEl = document.getElementById("custom-swiper-a");
    if (!swiperEl || !window.Swiper) return;

    if (swiperEl.swiper) {
      safeUpdateSwiper(swiperEl);
      return;
    }

    var prevBtn = swiperEl.querySelector(".swiper-button-prev");
    var nextBtn = swiperEl.querySelector(".swiper-button-next");

    new Swiper(swiperEl, {
      loop: true,
      watchSlidesProgress: false,
      centeredSlides: true,
      slidesPerView: 1.2,
      spaceBetween: 10,
      observer: false,
      observeParents: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      roundLengths: true,
      breakpoints: {
        700: {
          slidesPerView: 2,
          spaceBetween: 10,
          centeredSlides: true
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: true
        }
      },
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: false
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      }
    });

    bindButtonsOnce(document.querySelectorAll(".extra-prev"), prevBtn);
    bindButtonsOnce(document.querySelectorAll(".extra-next"), nextBtn);
  }

  function initReviewSwiper() {
    var swiperEl = document.getElementById("review-swiper");
    if (!swiperEl || !window.Swiper) return;

    if (swiperEl.swiper) {
      safeUpdateSwiper(swiperEl);
      return;
    }

    var isMobile = window.matchMedia("(max-width: 699px)").matches;
    var prevBtn = swiperEl.querySelector(".swiper-button-prev");
    var nextBtn = swiperEl.querySelector(".swiper-button-next");

    new Swiper(swiperEl, {
      loop: true,
      watchSlidesProgress: false,
      centeredSlides: isMobile,
      slidesPerView: isMobile ? 1.2 : 3,
      spaceBetween: isMobile ? 10 : 16,
      observer: false,
      observeParents: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      roundLengths: true,
      breakpoints: {
        700: {
          slidesPerView: 2,
          spaceBetween: 10,
          centeredSlides: false
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false
        }
      },
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: false
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true
      }
    });

    bindButtonsOnce(document.querySelectorAll(".extra-prev"), prevBtn);
    bindButtonsOnce(document.querySelectorAll(".extra-next"), nextBtn);
  }

  function initCustomLayoutSwiper() {
    var swiperEl = document.getElementById("custom-layout-swiper");
    if (!swiperEl || !window.Swiper) return;

    if (swiperEl.swiper) {
      safeUpdateSwiper(swiperEl);
      return;
    }

    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 12,
      centeredSlides: false,
      watchSlidesProgress: false,
      observer: false,
      observeParents: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      roundLengths: true,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: false
      },
      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true
      },
      keyboard: {
        enabled: true
      },
      a11y: {
        enabled: true,
        paginationBulletMessage: "Go to slide {{index}}"
      }
    });
  }

  function getVideoType(src) {
    if (!src) return "video/mp4";

    var cleanSrc = src.split("?")[0].toLowerCase();

    if (cleanSrc.indexOf(".webm") > -1) return "video/webm";
    if (cleanSrc.indexOf(".ogg") > -1 || cleanSrc.indexOf(".ogv") > -1) return "video/ogg";

    return "video/mp4";
  }

  function getVideoSrc(video) {
    if (!video) return "";

    if (video.dataset.videoSrc) return video.dataset.videoSrc;

    var source = video.querySelector("source");

    if (source && source.dataset.videoSrc) return source.dataset.videoSrc;
    if (source && source.src) return source.src;
    if (video.currentSrc) return video.currentSrc;
    if (video.src) return video.src;

    return "";
  }

  function saveVideoSrc(video) {
    if (!video) return "";

    var source = video.querySelector("source");
    var src = "";

    if (video.dataset.videoSrc) {
      src = video.dataset.videoSrc;
    } else if (source && source.dataset.videoSrc) {
      src = source.dataset.videoSrc;
    } else if (source && source.src) {
      src = source.src;
    } else if (video.currentSrc) {
      src = video.currentSrc;
    } else if (video.src) {
      src = video.src;
    }

    if (src) {
      video.dataset.videoSrc = src;

      if (source) {
        source.dataset.videoSrc = src;
      }
    }

    return src;
  }

  function clearVideo(video, options) {
    if (!video) return;

    var shouldRemovePoster = !options || options.removePoster !== false;

    try {
      video.pause();
    } catch (error) {}

    video.removeAttribute("src");

    if (shouldRemovePoster) {
      video.removeAttribute("poster");
    }

    while (video.firstChild) {
      video.removeChild(video.firstChild);
    }

    try {
      video.load();
    } catch (error) {}
  }

  function optimizePreviewVideo(video) {
    if (!video || video.dataset.videoPreviewOptimized === "true") return;

    var src = saveVideoSrc(video);
    var poster = video.getAttribute("poster") || "";

    video.dataset.videoPreviewOptimized = "true";

    if (poster) {
      video.dataset.videoPoster = poster;
    }

    video.setAttribute("preload", "none");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.removeAttribute("autoplay");
    video.removeAttribute("controls");

    video.muted = true;

    var trigger = video.closest("[data-video-open]");

    if (trigger && src) {
      trigger.dataset.videoSrc = src;
    }

    if (trigger && poster) {
      trigger.dataset.videoPoster = poster;
    }

    clearVideo(video, {
      removePoster: false
    });
  }

  function optimizeVideoSliderMedia(section) {
    if (!section) return;

    section.querySelectorAll("[data-video-open] video").forEach(function (video) {
      optimizePreviewVideo(video);
    });
  }

  function createVideoSwiper(section, swiperEl) {
    if (!section || !swiperEl || !window.Swiper) return;

    if (swiperEl.swiper) {
      safeUpdateSwiper(swiperEl);
      swiperEl.classList.add("is-ready");
      section.dataset.videoSliderReady = "true";
      return;
    }

    new Swiper(swiperEl, {
      loop: false,
      rewind: false,
      slidesPerView: 1.15,
      spaceBetween: 12,
      centeredSlides: false,

      speed: 420,
      watchSlidesProgress: false,
      watchOverflow: true,
      roundLengths: true,

      observer: false,
      observeParents: false,
      observeSlideChildren: false,

      preloadImages: false,
      updateOnWindowResize: true,
      resizeObserver: true,

      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      passiveListeners: true,
      touchStartPreventDefault: false,
      resistanceRatio: 0.85,

      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true
      },

      breakpoints: {
        750: {
          slidesPerView: 2.2,
          spaceBetween: 14
        },
        1000: {
          slidesPerView: 4,
          spaceBetween: 16
        }
      },

      on: {
        init: function () {
          swiperEl.classList.add("is-ready");
        },
        resize: function () {
          swiperEl.classList.add("is-ready");
        }
      }
    });

    swiperEl.classList.add("is-ready");
    section.dataset.videoSliderReady = "true";
  }

  function bindVideoSliderEvents(section) {
    if (!section || section.dataset.videoEventsBound === "true") return;

    var modal = section.querySelector("[data-video-modal]");
    var modalVideo = section.querySelector("[data-video-modal-player]");
    var closeBtn = section.querySelector("[data-video-close]");
    var modalProduct = section.querySelector("[data-video-modal-product]");

    section.dataset.videoEventsBound = "true";

    function resetModal() {
      clearVideo(modalVideo, {
        removePoster: true
      });

      if (modalProduct) {
        modalProduct.innerHTML = "";
      }
    }

    function openModal(trigger) {
      if (!modal || !modalVideo || !trigger) return;

      var video = trigger.querySelector("video");
      var src = trigger.dataset.videoSrc || getVideoSrc(video);
      var poster = trigger.dataset.videoPoster || (video ? video.getAttribute("poster") : "");

      if (!src) return;

      resetModal();

      var source = document.createElement("source");
      source.src = src;
      source.type = getVideoType(src);

      modalVideo.appendChild(source);

      if (poster) {
        modalVideo.setAttribute("poster", poster);
      }

      modalVideo.setAttribute("preload", "auto");
      modalVideo.setAttribute("playsinline", "");
      modalVideo.setAttribute("webkit-playsinline", "");

      var slide = trigger.closest(".swiper-slide");
      var productTemplate = slide ? slide.querySelector(".video-slider-modal-product-template") : null;

      if (productTemplate && modalProduct) {
        modalProduct.innerHTML = productTemplate.innerHTML;
      }

      modal.classList.add("is-active");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";

      try {
        modalVideo.load();

        var playPromise = modalVideo.play();

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      } catch (error) {}
    }

    function closeModal() {
      if (!modal) return;

      resetModal();

      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
    }

    section.querySelectorAll("[data-video-open]").forEach(function (trigger) {
      if (trigger.dataset.videoClickBound === "true") return;

      trigger.dataset.videoClickBound = "true";

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        openModal(trigger);
      });
    });

    section.querySelectorAll(".product-choice__item").forEach(function (item) {
      if (item.dataset.accessoriesTouchBound === "true") return;

      item.dataset.accessoriesTouchBound = "true";

      item.addEventListener(
        "touchstart",
        function () {
          var activeItems = section.querySelectorAll(".product-choice__item.is-accessories-visible");

          activeItems.forEach(function (activeItem) {
            if (activeItem !== item) {
              activeItem.classList.remove("is-accessories-visible");
            }
          });

          item.classList.add("is-accessories-visible");
        },
        { passive: true }
      );
    });

    if (closeBtn && closeBtn.dataset.videoCloseBound !== "true") {
      closeBtn.dataset.videoCloseBound = "true";
      closeBtn.addEventListener("click", closeModal);
    }

    if (modal && modal.dataset.videoModalBound !== "true") {
      modal.dataset.videoModalBound = "true";

      modal.addEventListener("click", function (event) {
        if (event.target === modal) {
          closeModal();
        }
      });
    }
  }

  function initVideoSliderSection(section) {
    if (!section) return;

    var swiperEl = section.querySelector("[data-video-slider-swiper]");
    if (!swiperEl || !window.Swiper) return;

    optimizeVideoSliderMedia(section);
    bindVideoSliderEvents(section);

    if (section.dataset.videoSliderReady === "true") {
      safeUpdateSwiper(swiperEl);
      return;
    }

    if ("IntersectionObserver" in window && section.dataset.videoObserverBound !== "true") {
      section.dataset.videoObserverBound = "true";

      section._videoSliderObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            observer.disconnect();
            section._videoSliderObserver = null;

            createVideoSwiper(section, swiperEl);
          });
        },
        {
          root: null,
          rootMargin: "700px 0px",
          threshold: 0
        }
      );

      section._videoSliderObserver.observe(section);
      return;
    }

    createVideoSwiper(section, swiperEl);
  }

  function initVideoSliders() {
    document.querySelectorAll("[data-video-slider-section]").forEach(function (section) {
      initVideoSliderSection(section);
    });
  }

  function closeAllVideoModals() {
    document.querySelectorAll("[data-video-modal].is-active").forEach(function (modal) {
      var modalVideo = modal.querySelector("[data-video-modal-player]");
      var modalProduct = modal.querySelector("[data-video-modal-product]");

      clearVideo(modalVideo, {
        removePoster: true
      });

      if (modalProduct) {
        modalProduct.innerHTML = "";
      }

      modal.classList.remove("is-active");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
    });
  }

  function initAllSwipers() {
    initCustomSwiper();
    initReviewSwiper();
    initCustomLayoutSwiper();
    initVideoSliders();
  }

  ready(initAllSwipers);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeAllVideoModals();
    }
  });

  document.addEventListener(
    "touchstart",
    function (event) {
      var activeItems = document.querySelectorAll(".product-choice__item.is-accessories-visible");

      if (!activeItems.length) return;

      activeItems.forEach(function (item) {
        var section = item.closest("[data-video-slider-section]");

        if (section && section.contains(event.target)) return;

        item.classList.remove("is-accessories-visible");
      });
    },
    { passive: true }
  );

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      closeAllVideoModals();
    }
  });

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-video-slider-section]");

    if (section) {
      section.dataset.videoSliderReady = "false";
      section.dataset.videoObserverBound = "false";
      initVideoSliderSection(section);
      return;
    }

    initAllSwipers();
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector("[data-video-slider-section]");
    if (!section) return;

    if (section._videoSliderObserver) {
      section._videoSliderObserver.disconnect();
      section._videoSliderObserver = null;
    }

    var swiperEl = section.querySelector("[data-video-slider-swiper]");

    if (swiperEl && swiperEl.swiper) {
      try {
        swiperEl.swiper.destroy(true, true);
      } catch (error) {}
    }

    section.dataset.videoSliderReady = "false";
  });
})();